import React from "react"
import { Tooltip } from 'rsuite'
import { Whisper } from 'rsuite'
import ActionIcons from "./ActionIcons"

const TooltipRsuite = (props) =>{
  return (
    <>
        <Whisper 
            placement={props.placement} 
            controlId={props.controlId}
            trigger={props.trigger}
            speaker={
                <Tooltip >
                    <>
                    <ul className='pl-20 password-tooltip mt-4 mb-4'>
                        <li>Must Be at least 8 characters</li>
                        <li>Have at least one number</li>
                        <li>Have at least one symbol !@#$%^&*_</li>
                        <li>Have at least one upper case letter</li>
                        <li>Have at least one lower case letter</li>
                    </ul>
                    </>
                </Tooltip>
            }
        >
            <span className='d-flex'><ActionIcons type='infofill' className='text-primary-common text-14 ml-4' /></span>
        </Whisper>
    </>
  )
}

export default TooltipRsuite

TooltipRsuite.defaultProps = {
    placement : 'top',
    trigger : 'hover',
    controlId : "control-id-hover",
}